import React, { Component, lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import LoadingWheel from './components/franchise_finder/LoadingWheel'

const ContactForm = React.lazy(() => import("./components/contact-form.js"));
const GuideComplete = React.lazy(() => import("./components/guide/guide_complete.js"));
const SectorCompanies = React.lazy(() => import("./components/company_details/company_sectors.js"));

const TwelveDayFullWidth = React.lazy(() => import("./components/signups/twelve-day-full-width.js"));
const SidebarTwelve = React.lazy(() => import("./components/signups/sidebar-twelve-days.js"));
const NewsletterPage = React.lazy(() => import("./components/signups/newsletter_page.js"));
const FooterNewsletter = React.lazy(() => import("./components/newsletter/footer_signup.js"));

const PopupSignup = React.lazy(() => import("./components/newsletter/popup_signup.js"));

if (document.querySelector("#oneClickEnquire")) {
    ReactDOM.render(<Enquiry />, document.querySelector("#oneClickEnquire"));
}

if (document.querySelector("#newsletterPopup")) {
    ReactDOM.render(
        <Router>
            <Suspense fallback={<LoadingWheel visible={true}/>}>
                <Route path="/" component={PopupSignup} />
            </Suspense>
        </Router>,
        document.querySelector("#newsletterPopup")
    );
}
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector("#footerNewsletter")) {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingWheel visible={true}/>}>
                    <Route path="/" component={FooterNewsletter} />
                </Suspense>
            </Router>,
            document.querySelector("#footerNewsletter")
        );
    }
    if (document.querySelector("#companySector")) {
        ReactDOM.render(
            <Router>
                <div>
                    <Suspense fallback={<LoadingWheel visible={true}/>}>
                        <Route path="/" component={SectorCompanies} />
                    </Suspense>
                </div>
            </Router>,
            document.querySelector("#companySector")
        );
    }

    if (document.querySelector("#newsletterSignup")) {
        ReactDOM.render(
            <Suspense fallback={<LoadingWheel visible={true}/>}>
                <NewsletterPage />
            </Suspense>,
            document.querySelector("#newsletterSignup")
        );
    }

    if (document.querySelector("#guide")) {
        ReactDOM.render(
            <Suspense fallback={<LoadingWheel visible={true}/>}>
                <GuideComplete />
            </Suspense>,
            document.querySelector("#guide")
        );
    }

    if (document.querySelector("#contactPage")) {
        ReactDOM.render(<Suspense fallback={<LoadingWheel visible={true}/>}><ContactForm /></Suspense>, document.querySelector("#contactPage"));
    }

    if (document.querySelector("#SidebarTwelve")) {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingWheel visible={true}/>}>
                    <Route path="/" component={SidebarTwelve} />
                </Suspense>
            </Router>,
            document.querySelector("#SidebarTwelve")
        );
    }
    
    if (document.querySelector(".twelveDayFullWidth")) {
        ReactDOM.render(
            <Router>
                <Suspense fallback={<LoadingWheel visible={true}/>}>
                    <Route path="/" component={TwelveDayFullWidth} />
                </Suspense>
            </Router>,
            document.querySelector(".twelveDayFullWidth")
        );
    }

    if (document.querySelector("#newsletter-container")) {
        ReactDOM.render(
            <div>
                <Suspense fallback={<LoadingWheel visible={true}/>}>
                    <Newsletter />
                </Suspense>
            </div>,
            document.querySelector("#newsletter-container")
        );
    }
})






